import {
  REQUEST_CATEGORY_LIST,
  REMOVE_CATEGORIES
} from './mutation-types';

export default {
  [REQUEST_CATEGORY_LIST] (state, receivedData) {
    state.categories = receivedData;
  },
  [REMOVE_CATEGORIES] (state) {
    state.categories = []
  }
}